import { Nullable } from "@tager/admin-services";
import { OptionType } from "@tager/admin-ui";
import {
  FieldUnion,
  RepeaterFieldConfig,
  RepeaterIncomingValue,
} from "@tager/admin-dynamic-field";

import { FieldOptionType, FullFieldType } from "@/typings/model";
import { FieldCreationPayload, FieldUpdatePayload } from "@/services/requests";
import { convertFieldUnionToArrayOfInputs } from "@/utils/common";

export type FormValues = {
  name: string;
  systemName: string;
  type: Nullable<OptionType>;
  adminNote: string;
  description: Nullable<string>;
  multiple: Nullable<boolean>;
  noLabel: Nullable<string>;
  yesLabel: Nullable<string>;
  options: Nullable<Array<FieldOptionType>>;
};

export const typeOptionList = [
  { value: "SELECT", label: "Выбор из вариантов" },
  { value: "NUMBER", label: "Число" },
  { value: "TRUE_FALSE", label: "Да / Нет" },
  { value: "COLOR", label: "Цвет" },
  { value: "STRING", label: "Текстовое поле" },
];

export function convertFieldToFormValues(
  field: Nullable<FullFieldType>
): FormValues {
  if (!field) {
    return {
      name: "",
      systemName: "",
      type: null,
      adminNote: "",
      description: null,
      multiple: null,
      noLabel: null,
      yesLabel: null,
      options: null,
    };
  }

  const currentTypeOption = typeOptionList.find(
    (option) => option.value === field.type
  );

  return {
    name: field.name ?? "",
    systemName: field.systemName ?? "",
    type: currentTypeOption ?? null,
    adminNote: field.adminNote ?? "",
    description: field.description ?? "",
    multiple: field.multiple ?? false,
    noLabel: field.noLabel ?? "",
    yesLabel: field.yesLabel ?? "",
    options: field.options ?? null,
  };
}

export function convertFormValuesToFieldCreationPayload(
  values: FormValues,
  productTypeId: number | string
): FieldCreationPayload {
  return {
    name: values.name ?? "",
    productTypeId: productTypeId,
    systemName: values.systemName ?? "",
    type: values.type?.value ?? "",
  };
}

export function convertFormValuesToFieldUpdatePayload(
  values: FormValues,
  inputSelectValues: FieldUnion,
  inputColorValues: FieldUnion
): FieldUpdatePayload {
  return {
    name: values.name ?? "",
    systemName: values.systemName ?? "",
    type: values.type?.value ?? "",
    adminNote: values.adminNote ?? "",
    description: values.description ?? "",
    multiple: values.type?.value === "SELECT" ? values.multiple : null,
    noLabel: values.noLabel ?? "",
    yesLabel: values.yesLabel ?? "",
    options:
      values.type?.value === "SELECT"
        ? convertFieldUnionToArrayOfInputs<FieldOptionType>(inputSelectValues)
        : null,
    colors:
      values?.type?.value === "COLOR"
        ? convertFieldUnionToArrayOfInputs<FieldOptionType>(inputColorValues)
        : null,
  };
}

/** Select creation table */

export const selectFieldConfig: RepeaterFieldConfig = {
  name: "inputs",
  type: "REPEATER",
  label: "Поля",
  meta: {
    view: "TABLE",
    defaultIsOpen: true,
  },
  fields: [
    {
      name: "id",
      type: "STRING",
      label: "ID",
      meta: {
        hidden: true,
      },
    },
    {
      name: "name",
      type: "STRING",
      label: "Название",
      meta: {},
    },
    {
      name: "systemName",
      type: "STRING",
      label: "Системное имя",
      meta: {},
    },
    {
      name: "canBeDeleted",
      type: "TRUE_FALSE",
      label: "Can be deleted",
      meta: {
        hidden: true,
        defaultValue: true,
      },
    },
  ],
};

export function convertSelectOptionListToRepeaterIncomingValue(
  selectOptionList: Nullable<Array<FieldOptionType>>
): RepeaterIncomingValue {
  console.log(selectOptionList);
  if (!selectOptionList) return [];
  console.log(
    selectOptionList.map((selectOption) => [
      { name: "name", value: selectOption.name },
      { name: "systemName", value: selectOption.systemName },
      { name: "id", value: String(selectOption.id) },
      { name: "canBeDeleted", value: selectOption.canDelete },
    ])
  );
  return selectOptionList.map((selectOption) => [
    { name: "name", value: selectOption.name },
    { name: "systemName", value: selectOption.systemName },
    { name: "id", value: String(selectOption.id) },
    { name: "canBeDeleted", value: selectOption.canDelete },
  ]);
}

/** Colors creation table */

export const colorFieldConfig: RepeaterFieldConfig = {
  name: "inputs",
  type: "REPEATER",
  label: "Цвета",
  meta: {
    view: "TABLE",
    defaultIsOpen: true,
  },
  fields: [
    {
      name: "id",
      type: "STRING",
      label: "ID",
      meta: {
        hidden: true,
      },
    },
    {
      name: "name",
      type: "STRING",
      label: "Название",
      meta: {},
    },
    {
      name: "color",
      type: "COLOR",
      label: "Цвет",
      meta: {},
    },
  ],
};

export function convertColorListToRepeaterIncomingValue(
  colorList: Nullable<Array<FieldOptionType>>
): RepeaterIncomingValue {
  if (!colorList) return [];
  return colorList.map((color) => [
    { name: "name", value: color.name },
    { name: "color", value: color.color },
    { name: "id", value: String(color.id) },
  ]);
}
